export const PRIMARY_MAXPARK_FUNCTION_ORIGIN = 'https://maxparksolutions.com';

const normalizeUrl = (value = '') => String(value || '').replace(/\/+$/, '');

const normalizeFunctionPath = (path = '') => {
    const normalizedPath = String(path || '').trim();
    return normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
};

export const getRuntimeHostname = () =>
    typeof window !== 'undefined' && window.location ? window.location.hostname : '';

export const isPrimaryMaxParkHostname = (hostname = '') =>
    /^(?:www\.)?maxparksolutions\.com$/i.test(String(hostname || '').trim());

export const isNonPrimaryMaxParkFunctionHost = (value = '') => {
    const normalized = normalizeUrl(value);

    if (!normalized) {
        return false;
    }

    try {
        const url = new URL(normalized);
        return url.protocol === 'https:' && (
            /^(?:www\.)?maxparksolutions\.ca$/i.test(url.hostname)
            || /^api\.maxparksolutions\.(ca|com)$/i.test(url.hostname)
        );
    } catch (error) {
        return /^https:\/\/(?:(?:www\.)?maxparksolutions\.ca|api\.maxparksolutions\.(?:ca|com))(?:\/|$)/i.test(normalized);
    }
};

export const isRetiredMaxParkApiUrl = isNonPrimaryMaxParkFunctionHost;

export const getSafeConfiguredUrl = (configuredUrl, fallbackUrl = '') => {
    const normalized = normalizeUrl(configuredUrl);

    if (!normalized || isNonPrimaryMaxParkFunctionHost(normalized)) {
        return fallbackUrl;
    }

    return normalized;
};

export const getConfiguredServerApi = () => {
    return getSafeConfiguredUrl(
        process.env.REACT_APP_SERVER_API ||
        process.env.REACT_APP_REMOTE_SERVER_API ||
        ''
    );
};

export const getFunctionUrl = (path, {
    env = process.env.NODE_ENV,
    hostname = getRuntimeHostname(),
    serverApi = getConfiguredServerApi(),
    localOrigin = 'http://localhost:5001',
} = {}) => {
    const normalizedPath = normalizeFunctionPath(path);

    if (serverApi) {
        return `${serverApi}${normalizedPath}`;
    }

    if (env === 'production') {
        return isPrimaryMaxParkHostname(hostname)
            ? normalizedPath
            : `${PRIMARY_MAXPARK_FUNCTION_ORIGIN}${normalizedPath}`;
    }

    return `${normalizeUrl(localOrigin)}${normalizedPath}`;
};
